import { Controller } from 'stimulus'

export default class extends Controller {
  declare idValue: number
  static values = { id: Number }

  connect() {
    fetch(`/ajax/jobs/count?id=${this.idValue}`)

    fetch(`/ajax/jobs/similar?id=${this.idValue}`)
      .then(res => {
        if (!res.ok) return null
        return res.json()
      })
      .then(data => {
        if (data?.html) this.element.innerHTML = data.html
      })
      .catch(() => {})
  }
}
